__turbopack_context__.v({
  "boxed": "nOkt8q_boxed",
  "energy": "nOkt8q_energy",
  "location": "nOkt8q_location",
  "wrapper": "nOkt8q_wrapper",
});
